import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';

@Pipe({ name: 'smartDate' })
export class SmartDatePipe implements PipeTransform {
  transform(value: string | Date): string {
    if (!value) return '';
    const date = new Date(value);
    const currentYear = new Date().getFullYear();
    const pipe = new DatePipe('en-US');
    // Same year: "Fri, Mar 27" — different year: "Fri, Mar 27, 2027"
    const format = date.getFullYear() !== currentYear ? 'EEE, MMM d, yyyy' : 'EEE, MMM d';
    return pipe.transform(date, format) || '';
  }
}
